import React from "react";
import { Avatar } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const ProfileAvatar = ({ size = 40, onClick }) => {
  return (
    <Avatar
      onClick={onClick}
      sx={{
        width: size,
        height: size,
        bgcolor: "grey.300",
        cursor: "pointer",
      }}
    >
      <PersonIcon sx={{ fontSize: size * 0.6, color: "grey.700" }} />
    </Avatar>
  );
};

export default ProfileAvatar;
